import type { ComboboxOption } from "@/components/Combobox/types";
import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";

/**
 * GET /v2/components/devices-for-select
 * セレクト用のデバイス一覧を取得
 */
export const getDevicesForSelect = async (
  searchText?: string,
): Promise<ComboboxOption[]> => {
  const res = await apiClient.GET("/v2/components/devices-for-select", {
    params: {
      query: {
        orderBy: "name",
        orderDirection: "asc",
        freeText: searchText || undefined,
      },
    },
  });
  const data = getDataOrThrowApiError(res);
  const items = data?.items ?? [];

  return items.map(
    (device: { id: string; name: string; avatarUrl?: string | null }) => ({
      value: device.id,
      label: device.name,
      key: device.id,
      avatarUrl: device.avatarUrl ?? undefined,
    }),
  );
};

/**
 * GET /v2/components/place-select
 * セレクト用の拠点一覧を取得
 */
export const getPlacesForSelect = async (
  searchText?: string,
): Promise<ComboboxOption[]> => {
  const res = await apiClient.GET("/v2/components/place-select", {
    params: {
      query: {
        orderBy: "ADDRESS",
        orderDirection: "asc",
        freeText: searchText || undefined,
      },
    },
  });
  const data = getDataOrThrowApiError(res);
  const items = data?.items ?? [];

  return items.map((place: { id: string; name: string }) => ({
    value: place.id,
    label: place.name,
    key: place.id,
  }));
};

/**
 * GET /v2/workers-for-select
 * セレクト用の担当者一覧を取得
 */
export const getWorkersForSelect = async (
  searchText?: string,
): Promise<ComboboxOption[]> => {
  const res = await apiClient.GET("/v2/workers-for-select", {
    params: {
      query: {
        orderDirection: "asc",
        freeText: searchText || undefined,
      },
    },
  });
  const data = getDataOrThrowApiError(res);
  const items = data?.items ?? [];

  return items.map(
    (worker: {
      personId: string;
      name: string;
      primaryWorkerEmail?: string | null;
      avatarUrl?: string | null;
    }) => ({
      value: worker.personId,
      label: worker.name,
      key: worker.personId,
      email: worker.primaryWorkerEmail ?? undefined,
      avatarUrl: worker.avatarUrl ?? undefined,
    }),
  );
};
